import { Group, Mesh, PlaneGeometry, MeshBasicMaterial, Vector3, Vector2 } from 'three';
import { TextComponent, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class Preloader extends ViewerModule {
    constructor(options) {
        super();
        this.options = options;
        this.text = this.options.text || 'Loading';
        this.color = this.options.color || '#444444';
        this.position = this.options.position || new Vector3(0, 0, 0);
        this.mainContainer = new Group();
        this.mainContainer.name = 'Main Container';
        this.mainContainer.position.copy(this.position);
        this.addObject(this.mainContainer);
    }
    init() {
        this.planeTop = new Mesh(new PlaneGeometry(0.3, 0.3), new MeshBasicMaterial({ color: this.color, side: 2 }));
        const yoffset = 0.2;
        const xoffset = -1.5;
        this.planesContainerTop = new Group();
        this.planesContainerTop.name = 'Planes Container Top';
        this.planesContainerTop.position.set(xoffset, yoffset, 0);
        this.planesContainerTop.add(this.planeTop);
        this.planeBot = new Mesh(new PlaneGeometry(0.3, 0.3), new MeshBasicMaterial({ color: this.color, side: 2 }));
        this.planesContainerBot = new Group();
        this.planesContainerBot.name = 'Planes Container Bot';
        this.planesContainerBot.position.set(xoffset, -yoffset, 0);
        this.planesContainerBot.add(this.planeBot);
        this.textComponent = new TextComponent({
            size: new Vector2(2, 1),
            pxSize: new Vector2(512 / 2, 256 / 2).multiplyScalar(window['quality'] === 'very low' ? 0.6 : 1),
            text: {
                value: this.text,
                autoWrappingHorizontal: true,
                autoWrapping: true,
                lineHeight: (60 / 2) * (window['quality'] === 'very low' ? 0.6 : 1),
                align: 'center',
                style: { size: `${(60 / 2) * (window['quality'] === 'very low' ? 0.6 : 1)}px`, family: 'Nunito', color: this.color },
            },
            background: { color: 'transparent' }
        });
        this.textComponent.uiObject.position.y = 0.2;
        this.mainContainer.add(this.textComponent.uiObject);
        this.textComponent2 = new TextComponent({
            size: new Vector2(3, 1.5),
            pxSize: new Vector2(512 / 1.2, 256 / 1.2).multiplyScalar(window['quality'] === 'very low' ? 0.6 : 1),
            text: {
                value: 'We are loading your experience. This might take a moment.',
                autoWrappingHorizontal: true,
                autoWrapping: false,
                lineHeight: (60 / 1.2) * (window['quality'] === 'very low' ? 0.6 : 1),
                align: 'center',
                style: { size: `${(30 / 1.2) * (window['quality'] === 'very low' ? 0.6 : 1)}px`, family: 'Nunito', color: this.color },
            },
            background: { color: 'transparent' }
        });
        this.textComponent2.uiObject.position.y = -1;
        this.mainContainer.add(this.textComponent2.uiObject);
    }
}
